import React from 'react';
import { ResourceTemporaryUsersScreen, Icons } from '@leverege/api-ui-user-management';
import I18N from '@leverege/i18n';
import { jsx as _jsx } from "react/jsx-runtime";
const {
  t
} = I18N.ns('molten.screens.UserManagement.TemporaryUserManagementScreen');
export default class MobileUserManagementScreen extends React.Component {
  constructor(props) {
    super(props);
    this.ref = /*#__PURE__*/React.createRef();
  }
  componentDidMount() {
    const {
      title,
      setTitle,
      setIcon,
      setActionsMatchContext,
      setActionsContext
    } = this.props;
    setTitle?.({
      data: title || t('title')
    });
    setIcon?.({
      data: Icons.screenIcon
    });
    setActionsMatchContext?.({
      data: ResourceTemporaryUsersScreen.ACTION_MATCH
    });
    setActionsContext?.({
      data: this.ref?.current?.getContext.bind(this.ref?.current)
    });
  }
  render() {
    return /*#__PURE__*/_jsx(ResourceTemporaryUsersScreen, {
      ref: this.ref,
      showHeader: false,
      ...this.props
    });
  }
}